import React, { useEffect, useState, useRef, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Grid,
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  IconButton,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextareaAutosize,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Select,
  TableRow,
  Paper,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Chip,
  FormControl,
  InputLabel,
  CircularProgress,
  Backdrop,
  Stack,Popover
} from "@mui/material";
import { DownloadOutlined, SpeakerNotesOutlined } from "@mui/icons-material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ClearIcon from "@mui/icons-material/Clear";
import CommentIcon from "@mui/icons-material/Comment";
import { useSelector, useDispatch } from "react-redux";
import { diff } from "deep-diff";
import CollapseSection from "../../../components/ui/CollapseSection";
import "./Modification.css";
import RowModification from "./RowModification";
import ConsumptionRatio from "../../Dashboard/ConsumptionRatio";
import {
  GetScenarios,
  SubmitModification,
  setState,
  ExportExcel,
  UnblockFullOrderMSQ,
  ImportExcel,
  DownloadFile,
  addFile,
  deleteFile,
  Upload,
  reset
} from "../reviewSlice";
import _ from "lodash";
import * as XLSX from "xlsx";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import AttachmentIcon from "@mui/icons-material/Attachment";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { green, orange, red, grey, blue } from "@mui/material/colors";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltTwoToneIcon from '@mui/icons-material/FilterAltTwoTone';

const Modification = (props) => {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchProduct, setSearchProduct] = useState("");
  //const [pageSize, setPageSize] = React.useState(20);
  const [rows, setRows] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [isDisplayBlockedCustomers, setIsDisplayBlockedCustomers] =
    useState(false);
  const theme = useTheme();
  const [selectedWeeklyData, setSelectedWeeklyData] = useState([]);
  //const [oldWeeklyData, setOldWeeklyData] = useState({});
  //const [newWeeklyData, setNewWeeklyData] = useState({});
  //const [totalQuota, setTotalQuota] = useState(0);
  //const [revisedQuota, setRevisedQuota] = useState(0);
  //const [difference, setDifference] = useState(0);
  const [modificationPercentage, setModificationPercentage] = useState("");
  const [isOnlySelectedCustomers, setIsOnlySelectedCustomers] = useState(false);
  const modPercFunc = useRef();
  const rounderFunc = useRef();
  const pullForwardFunc = useRef();
  const ModRef = useRef(null);
  const [rounder, setRounder] = useState("");
  const [isCheckedHeader, setIsCheckedHeader] = useState({
    isCheckedWeekly1: false,
    isCheckedWeekly2: false,
    isCheckedWeekly3: false,
    isCheckedWeekly4: false,
    isCheckedWeekly5: false,
  });
  const [currentWeek, setCurrentWeek] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const setIsCollapseOpened = props.setIsCollapseOpened;

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
  const [displayFileButtons, setDisplayFileButtons] = useState(false);

  const [updatedRowIds, setUpdatedRowIds] = useState([]);
  const [weeklyPullForward, setWeeklyPullForward] = useState([]);

  const selectInitialValues = [
    "New Final Quota",
    "Delta Modifications",
    "Last Approved Modification",
    "Initial Quota",
  ];

  const [selectedValues, setSelectedValues] = useState(selectInitialValues);
  const [uploadedFile, setUploadedFile] = useState(null);
  const hiddenFileInput = useRef(null);
  const [excelCustomerIds, setExcelCustomerIds] = useState([]);
  const [mainComments, setMainComments] = useState("");
  const [userComments, setUserComments] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null); // Track the selected row
  const [commentData, setCommentData] = useState([]);
  const inputRef = useRef(null);
  const [customerTrustLvl, setcustomerTrustLvl] = React.useState([]);
  const [customerType, setcustomerType] = React.useState([]);
  const [selectedHeaders, setSelectedHeaders] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorType, setAnchorType] = useState(null);
  const dispatch = useDispatch();

  const review = useSelector((state) => state.review);
  const {
    selectedPeriod,
    selectedCountry,
    selectedCountryID,
    selectedScenario,
    selectedScenarioID,
    getQuotaDetails,
    currentSelectedScenario,
    getWeekStatus,
    quotaConsumptionTableState,
    checkedCustomersList,
    updatedWeeklyData,
    isLoading,
    excelData,
    modifyList,
    CustomerSearchTxt,
    ProductSearchTxt,
    isDisplayBlocked,
    ModifiedList,
    files,
    displayModification,
    clearMTable,
    selectedOrderStatus,
    searchTxt,
    onUnblockClicked,
    customerListForDecisionSubmission,
    selectedCustomersForDecision,
    isCurrentWeekRowChanged,
    modificationId,
    getScenarios,
    onMSQClicked,
    onUnblockClickedSubmitted,
    isModifyClicked,
    customerTrustLevel,
    customerTypes
  } = review;
  const apiRef = useGridApiRef();

  const handleHeaderChecked = (e) => {
    //console.log(e);
    setIsCheckedHeader((prev) => {
      return { ...isCheckedHeader, [e.target.name]: e.target.checked };
    });
  };

  // useEffect(()=>{
  //   debugger
  //   let item = [...rows];
  //   let idx = item.map(x=>x.customerQuotaID);
  //   idx = idx.filter((customerQuotaID) => !rowSelectionModel.includes(customerQuotaID));
  //   if(idx.length == 0 && rows.length ===  rowSelectionModel.length){
  //     setIsOnlySelectedCustomers(true);
  //   }else{
  //     setIsOnlySelectedCustomers(false);
  //   }
  // },[rows])

  useEffect(() => {
    debugger;
    dispatch(
      setState("updatedWeeklyData", ModifiedList?.quotaCusumptionCustomers)
    );
    if(searchProduct === undefined)setSearchProduct("");
    if(searchCustomer === undefined)setSearchCustomer("");
    setcustomerType([]);
    setcustomerTrustLvl([]);
    if(isOnlySelectedCustomers){
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          if (rowSelectionModel !== undefined) {
            retVal = rowSelectionModel.includes(item.customerQuotaID);
          } else {
            return retVal;
          }
          return retVal;
        });
        return val;
      });
    }else if(isDisplayBlocked){
      filterSetRow(ModifiedList?.quotaCusumptionCustomers);
    }else{
      setRows(ModifiedList.quotaCusumptionCustomers);
    }
    if(isModifyClicked){
      scrollToThirdDataGrid();
    }
  }, [ModifiedList]);

  useEffect(() => {
    if (clearMTable) {
      setIsCheckedHeader({
        isCheckedWeekly1: false,
        isCheckedWeekly2: false,
        isCheckedWeekly3: false,
        isCheckedWeekly4: false,
        isCheckedWeekly5: false,
      });
      setUpdatedRowIds([]);
      setModificationPercentage("");
      setRounder("");
      setUserComments({});
      dispatch(setState("clearMTable", false));
    }
  }, [clearMTable]);

  const scrollToThirdDataGrid = () => {
    setTimeout(() => {
      if (ModRef.current) {
        ModRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 1000);
  };

  useEffect(() => {
    if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
      setCurrentWeek(1);
    } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
      if (getWeekStatus.chkFirstHalf == true) {
        setCurrentWeek(1);
      } else if (getWeekStatus.chkSecondHalf == true) {
        setCurrentWeek(2);
      }
    } else {
      if (getWeekStatus.chkMonth == true) {
        if (getWeekStatus.chkWeek1 == true) {
          setCurrentWeek(1);
        } else if (getWeekStatus.chkWeek2 == true) {
          setCurrentWeek(2);
        } else if (getWeekStatus.chkWeek3 == true) {
          setCurrentWeek(3);
        } else if (getWeekStatus.chkWeek4 == true) {
          setCurrentWeek(4);
        } else if (getWeekStatus.chkWeek5 == true) {
          setCurrentWeek(5);
        }
      } else {
        setCurrentWeek(0);
      }
    }
    if(isModifyClicked){
      scrollToThirdDataGrid();
    }
  }, [getWeekStatus, ModifiedList]);

  const handleHeaderClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleHeaderTypeClick = (event) => {
    setAnchorType(anchorType ? null : event.currentTarget);
  };
  const handleCloseTrust = () => {
    setAnchorEl(null);
  };
  const handleCloseType = () => {
    setAnchorType(null);
  };

  const handleCheckboxChange = (category) => {
    setcustomerTrustLvl((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };

  const handleCheckboxTypeChange = (category) => {
    setcustomerType((prev) =>
      prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
  };


  const w = 95;
  const columns = [
    {
      field: "customerName",
      headerName: "Customer / CG",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "sapCustomerNumber",
      headerName: "Customer Number",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "skuName",
      headerName: "SKU / PG",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "skuNumb",
      headerName: "SKU Number",
      flex: 1,
      minWidth: 100,
    },    {
      field: "customerType",
      headerName: "Customer Type",
      flex : 1,
      minWidth: 170,
      sortable: false,
      renderHeader: () => (
        <div>
        <div onClick={handleHeaderTypeClick} 
        style={{ display: 'flex', justifyContent: 'space-between', wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '14px', cursor: 'pointer', lineHeight: '1.2' }}> 
        <span>Customer Type  </span> 
        {customerType?.length === 0 &&<FilterAltOutlinedIcon style={{ color: '#bcbcba', fontSize : '20px'}} />}
        {customerType?.length > 0 && <FilterAltTwoToneIcon style={{ color: '#6f6f6c', fontSize : '20px'}} />}
        </div>
        <Popover
        open={Boolean(anchorType)}
        anchorEl={anchorType}
        onClose={handleCloseType}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: 16, maxHeight: '200px', overflowY: 'auto' }}>
          {customerTypes.map((category) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={customerType.includes(category)}
                  onChange={() => handleCheckboxTypeChange(category)}
                />
              }
              label={category}
              key={category}
              style={{ display: 'block' }}
            />
          ))}
        </div>
      </Popover>
      </div>
      ),
    },
    {
      field: "customerTrustLevel",
      headerName: "Customer trust level",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderHeader: () => (
        <div>
        <div onClick={handleHeaderClick} 
        style={{ display: 'flex', justifyContent: 'space-between', wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '14px', cursor: 'pointer', lineHeight: '1.2' }}> 
        <span>Customer Trust Level</span> 
        {customerTrustLvl?.length === 0 &&<FilterAltOutlinedIcon style={{ color: '#bcbcba', fontSize : '25px', paddingTop : '5px'}} />}
        {customerTrustLvl?.length > 0 && <FilterAltTwoToneIcon style={{ color: '#6f6f6c', fontSize : '25px', paddingTop : '5px'}} />}
        </div>

        <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseTrust}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: 16, maxHeight: '200px', overflowY: 'auto' }}>
          {customerTrustLevel.map((category) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={customerTrustLvl.includes(category)}
                  onChange={() => handleCheckboxChange(category)}
                />
              }
              label={category}
              key={category}
              style={{ display: 'block' }}
            />
          ))}
        </div>
      </Popover>
      </div>
      ),
      renderCell: (params) => {
        return (
          <Chip
            sx={{ height: "1.2rem" }}
            variant="outlined"
            {...getChipProps(params)}
          />
        );
      },
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "unusedQuota",
      headerName: "Unused Quota - Previous Period",
      width: 130,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      } 
    },
    {
      field: "quota",
      headerName: "Quota",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      } 
    },
    {
      field: "consumption",
      headerName: "Consumption",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      } 
    },
    {
      field: "availableQuota",
      headerName: "Available Quota",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        let idx = updatedWeeklyData.findIndex(
          (item) => item.customerQuotaID === params.row.customerQuotaID
        );
        let availableQuota = 0;
        if (idx > -1) {
          if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
            availableQuota =
              updatedWeeklyData[idx].newFinalQuota.weekly1 -
              params.row.consumption
          } else if (
            ModifiedList?.depletionModel?.toLowerCase() === "biweekly"
          ) {
            if (currentWeek === 1) {
              availableQuota = 
                updatedWeeklyData[idx].newFinalQuota.weekly1 -
                params.row.consumption
            } else {
              availableQuota = 
                updatedWeeklyData[idx].newFinalQuota.weekly2 -
                params.row.consumption
            }
          } else {
            if (currentWeek === 1) {
              availableQuota = 
                updatedWeeklyData[idx].newFinalQuota.weekly1 -
                params.row.consumption
            } else if (currentWeek === 2) {
              availableQuota = 
                updatedWeeklyData[idx].newFinalQuota.weekly2 -
                params.row.consumption
            } else if (currentWeek === 3) {
              availableQuota = 
                updatedWeeklyData[idx].newFinalQuota.weekly3 -
                params.row.consumption
            } else if (currentWeek === 4) {
              availableQuota = 
                updatedWeeklyData[idx].newFinalQuota.weekly4 -
                params.row.consumption
            } else {
              availableQuota = 
                updatedWeeklyData[idx].newFinalQuota.weekly5 -
                params.row.consumption
            }
          }
          return availableQuota;
        }
      },
    },
    {
      field: "intendedQuantity",
      headerName: "Intended Quantity",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      } 
    },
    {
      field: "modifiedOrderQtyUoM",
      headerName: "Modified Quantity",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      } 
    },
    // {
    //     field: "consumption",
    //     headerName: "Consumption",
    //     flex: 1, minWidth: 100,
    // },
    // {
    //     field: "intendedQuantity",
    //     headerName: "Intended Quantity",
    //     flex: 1, minWidth: 100,
    // },
    {
      field: "rowInfo",
      headerName: "Row",
      flex: 2,
      minWidth: 250,
      renderCell: (params) => {
        const style = {
          p: 0,
          width: "100%",
          maxWidth: 400,
          //borderRadius: 2,
          //border: '1px solid',
          //borderColor: 'divider',
          //backgroundColor: 'background.paper',
        };
        return (
          // <Grid container row-direction="column">
          <List sx={style}>
            <div>
              {selectedValues.includes("New Final Quota") && (
                <ListItem>
                  <ListItemText primary={params.row.newFinalQuota.row} />
                </ListItem>
              )}
              {selectedValues.includes("Delta Modifications") && (
                <ListItem>
                  <ListItemText primary={params.row.deltaModification.row} />
                </ListItem>
              )}
              {selectedValues.includes("Last Approved Modification") && (
                <ListItem>
                  <ListItemText primary={params.row.lastApproved.row} />
                </ListItem>
              )}
              {selectedValues.includes("Initial Quota") && (
                <ListItem>
                  <ListItemText primary={params.row.initialQuota.row} />
                </ListItem>
              )}
              <Divider fullWidth component="li" />
            </div>
          </List>
        );
      },
    },
    {
      field: "weekly1",
      headerName: "Week1",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek1,
      flex: 1,
      minWidth: 135,
      renderHeader: () => (
        <FormControlLabel
          label={
            ModifiedList?.depletionModel?.toLowerCase() === "none" ? (
              <span
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                }}
              >
                Final<br></br>Quota
              </span>
            ) : ModifiedList?.depletionModel?.toLowerCase() === "biweekly" ? (
              <span
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                }}
              >
                First<br></br>Half
              </span>
            ) : (
              <span
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "MontSerrat, Sans-serif",
                }}
              >
                Week1
              </span>
            )
          }
          control={
            <Checkbox
              disabled={
                ModifiedList?.depletionModel?.toLowerCase() !== "none" &&
                !getWeekStatus.chkWeek1
              }
              checked={isCheckedHeader.isCheckedWeekly1}
              name="isCheckedWeekly1"
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly1"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "weekly2",
      headerName: "Week2",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek2,
      flex: 1,
      minWidth: 135,
      renderHeader: () => (
        <FormControlLabel
          label={
            ModifiedList?.depletionModel?.toLowerCase() === "biweekly" ? (
              <span
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                }}
              >
                Second<br></br>Half
              </span>
            ) : (
              <span
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                }}
              >
                Week2
              </span>
            )
          }
          control={
            <Checkbox
              disabled={
                ModifiedList?.depletionModel?.toLowerCase() !== "biweekly" &&
                !getWeekStatus.chkWeek2
              }
              checked={isCheckedHeader.isCheckedWeekly2}
              name="isCheckedWeekly2"
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly2"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "weekly3",
      headerName: "Week3",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek3,
      flex: 1,
      minWidth: 135,
      renderHeader: () => (
        <FormControlLabel
          label={
            <span
              style={{
                fontWeight: "bold",
                color: "black",
                fontSize: "15px",
                fontFamily: "Montserrat, Sans-serif",
              }}
            >
              Week3
            </span>
          }
          control={
            <Checkbox
              disabled={!getWeekStatus.chkWeek3}
              checked={isCheckedHeader.isCheckedWeekly3}
              name="isCheckedWeekly3"
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly3"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "weekly4",
      headerName: "Week4",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek4,
      flex: 1,
      minWidth: 135,
      renderHeader: () => (
        <FormControlLabel
          label={
            <span
              style={{
                fontWeight: "bold",
                color: "black",
                fontSize: "15px",
                fontFamily: "Montserrat, Sans-serif",
              }}
            >
              Week4
            </span>
          }
          control={
            <Checkbox
              disabled={!getWeekStatus.chkWeek4}
              checked={isCheckedHeader.isCheckedWeekly4}
              name="isCheckedWeekly4"
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly4"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "weekly5",
      headerName: "Week5",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek5,
      flex: 1,
      minWidth: 135,
      renderHeader: () => (
        <FormControlLabel
          label={
            <span
              style={{
                fontWeight: "bold",
                color: "black",
                fontSize: "15px",
                fontFamily: "Montserrat, Sans-serif",
              }}
            >
              Week5
            </span>
          }
          control={
            <Checkbox
              disabled={!getWeekStatus.chkWeek5}
              checked={isCheckedHeader.isCheckedWeekly5}
              name="isCheckedWeekly5"
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly5"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "todaysConsumption",
      headerName: "Today's Consumption",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      } 
    },
    {
      field: "yesterdaysConsumption",
      headerName: "Yesterday's Consumption",
      flex: 1,
      minWidth: 100,
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString();
        return formattedValue;
      } 
    },
    // {
    //     field: "deliveredQty",
    //     headerName: "Delivered Quantity",
    //     flex: 1, minWidth: 100,
    // },
    {
      field: "stickToQuota",
      editable: false,
      headerName: "AT-STQ",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        let checked = cellValues.row.stickToQuota;
        const label = { inputProps: { "aria-label": "Checkbox" } };
        return checked === 1 ? (
          <Checkbox {...label} defaultChecked disabled />
        ) : (
          <Checkbox {...label} disabled />
        );
      },
    },
    {
      field: "customerComments",
      headerName: "Comments",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        return (
          <DisplayComments comments={cellValues.value} params={cellValues} />
        );
      },
      // renderCell: (params) => {
      //     const rowId = params.row.customerQuotaID;
      //     return (
      //         <div>
      //             {/* <IconButton
      //                 color="primary"
      //                 aria-label="comment"
      //                 onClick={() => handleEditClick(rowId)}
      //             >
      //                 <CommentIcon
      //                     sx={{ color: userComments[rowId] !== userComments[selectedRowId] ? 'blue.main' : 'grey.dark' }}
      //                     title={userComments[rowId] || ''} />
      //             </IconButton> */}
      //         </div>
      //     );
      // },
    },
  ];

  const ModifyWeeklyValues = (props) => {
    let params = props.params;
    let styles = props.styles;
    let type = props.type;

    return (
      <TextField
        sx={{ maxWidth: "100px" }}
        type="text"
        value={params.row[`${type}`]}
        name={type}
        className={styles}
      />
    );
  };

  function getChipProps(params) {
    if (params.value === "Low") {
      return {
        label: "Low",
        style: {
          fontWeight: "bold",
          borderColor: red[500],
          backgroundColor: red[50],
          color: red[500],
        },
      };
    } else if (params.value === "Medium") {
      return {
        label: "Medium",
        style: {
          fontWeight: "bold",
          borderColor: orange[500],
          backgroundColor: orange[50],
          color: orange[500],
        },
      };
    } else if (params.value === "High") {
      return {
        label: "High",
        style: {
          fontWeight: "bold",
          borderColor: green[500],
          backgroundColor: green[50],
          color: green[500],
        },
      };
    } else {
      return {
        label: "Other",
        style: {
          fontWeight: "bold",
          borderColor: blue[500],
          backgroundColor: blue[50],
          color: blue[500],
        },
      };
    }
  }

  // useEffect(() => {
  //     let filteredArray = updatedWeeklyData?.map(item => {
  //         if(item.customerComments !== ""){
  //             return {customerQuotaID:item.customerQuotaID,customerComments:item.customerComments}
  //         }
  //     })
  //     console.log(filteredArray);

  //     const convertedObject = filteredArray.reduce((obj, item) => {
  //         obj[item.customerQuotaID] = item.customerComments;
  //         return obj;
  //       }, {});

  //       setUserComments(convertedObject);

  // },[])

  // const handleConfirm = (e) => {
  //     setOpen(false);
  // }

  // const handleClose = () => {
  //     setOpen(false);
  // };

  const DisplayComments = (params) => {
    const [displayComments, setDisplayComments] = useState(params.comments);
    const [userCommentsLocal, setUserCommentsLocal] = useState("");
    const [open, setOpen] = useState(false);
    const rowId = params.params.row.customerQuotaID;
    const color =
      params.comments.length > 0 &&
      params.comments != "Default Customer quota record"
        ? "blue"
        : "black";

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const handleConfirm = () => {
      setDisplayComments(userCommentsLocal);
      const updatedComments = { ...userComments, [rowId]: userCommentsLocal };
      setUserComments(updatedComments);
      let currentState = _.cloneDeep(updatedWeeklyData);
      const updatedArray = currentState.map((item) => ({
        ...item,
        customerComments:
          updatedComments[item.customerQuotaID] || item.customerComments,
      }));
      setCommentData(updatedArray);
      dispatch(setState("updatedWeeklyData", updatedArray));
      let selectedCQID = rows.map(x=>x.customerQuotaID);
      //console.log(rows);
      setRows(updatedArray.filter((row) => selectedCQID.includes(row.customerQuotaID)));
      //setUserComments()
      setOpen(false);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleEditClick = (rowId) => {
      setSelectedRowId(rowId);
      setOpen(true);
    };

    const handleComments = (e) => {
      setUserCommentsLocal(e.target.value);
    };

    return (
      <div>
        <>
          <IconButton
            onClick={() => setOpen(true)}
            title={
              userComments[rowId]
                ? userComments[rowId]
                : params.params.row.customerComments
            }
          >
            {params.comments || userComments[rowId] ? (
              <CommentIcon
                title={
                  userComments[rowId] ? userComments[rowId] : params.comments
                }
                sx={{ color: "#007DC3" }}
              />
            ) : (
              <CommentIcon />
            )}
          </IconButton>

          <Dialog
            //disableEnforceFocus
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            //aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <TextareaAutosize
                  //onChange={(event) => setUserComments(event.target.value)}
                  onChange={handleComments}
                  aria-label="minimum height"
                  minRows={5}
                  //readOnly
                  placeholder="Comments"
                  style={{ width: 500, fontSize: 18 }}
                  defaultValue={
                    userComments[rowId]
                      ? userComments[rowId]
                      : params.params.row.customerComments
                  }
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                onClick={handleClose}
                size="small"
                style={{
                  background: "#286aa6",
                  color: "white",
                  borderRadius: "4px",
                }}
              >
                Cancel
              </Button>
              <Button
                autoFocus
                variant="contained"
                onClick={handleConfirm}
                size="small"
                style={{
                  background: "#286aa6",
                  color: "white",
                  borderRadius: "4px",
                }}
              >
                Save Changes
              </Button>
            </DialogActions>
          </Dialog>
        </>
      </div>
    );
  };

  useEffect(() => {
    if (userComments !== null || userComments !== undefined) {
      const keysArray = Object.keys(userComments).map(Number);
      setRowSelectionModel(keysArray);
      keysArray.forEach((item) => getUpdatedRowIds(item));
      //console.log(updatedArray);
    }
  }, [userComments]);
  //console.log(userComments);

  // const DisplayComments = (params) => {
  //     const [displayComments, setDisplayComments] = useState(params.comments);
  //     const [userCommentsLocal, setUserCommentsLocal] = useState("");
  //     const [open, setOpen] = useState(false);
  //     const color =
  //         params.comments.length > 0 &&
  //             params.comments != "Default Customer quota record"
  //             ? "blue"
  //             : "black";

  //     const theme = useTheme();
  //     const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  //     return (
  //         <>
  //             <IconButton
  //                 onClick={() => setOpen(true)}
  //                 title={displayComments}
  //                 sx={{ color: color }}
  //             >
  //                 {displayComments ? (
  //                     <CommentIcon title={displayComments} />
  //                 ) : (
  //                     <CommentIcon />
  //                 )}
  //             </IconButton>

  //         </>
  //     );
  // };

  const handleSearchCustomer = (e) => {
    const value = e.target.value;
    setSearchCustomer(value);
  };

  const handleSearchProduct = (e) => {
    const value = e.target.value;
    setSearchProduct(value);
  };

  const handleSelectChange = (event) => {
    const { value } = event.target;
    setSelectedValues(value);
  };

  //console.log(selectedValues);

  const handleSelectDelete = (value) => () => {
    //console.log(value);
    setSelectedValues((selectedValues) =>
      selectedValues.filter((selected) => selected !== value)
    );
  };

  const handleChooseFile = () => {
    setDisplayFileButtons((prevShow) => !prevShow);
  };

  const getUpdatedRowIds = (id) => {
    setUpdatedRowIds((updatedRowIds) => [...updatedRowIds, id]);
  };

  const handleSubmit = () => {
    let isValid = IsValid();
    if (isValid === true) {
      dispatch(Upload({ method: "POST" })).then(() => {
        handleSubmitModification();
        if (onUnblockClicked || onMSQClicked) {
          dispatch(setState("onUnblockClickedSubmitted", true));
        }
      });
    }
  };

  const handleSubmitModification = () => {
    let userData = JSON.parse(localStorage.getItem("data"));
    userData["token"] = "";
    userData["userCountries"] = null;
    userData["userCustomerTypes"] = null;

    //console.log(selectedWeeklyData);
    // const previousDataMap = new Map();
    // getQuotaDetails.quotaCusumptionCustomers.forEach((row) => {
    //   previousDataMap.set(row.customerQuotaID, row);
    // });
    
    let onlyUpdatedData = [];
    updatedWeeklyData.forEach((data) => {
      const newData = data.newFinalQuota;
      const previousData = data.lastApproved;
      const dataChanged = ['weekly1', 'weekly2', 'weekly3', 'weekly4', 'weekly5'].some(
        (key) => previousData[key] !== newData[key]
      );
    
      if (dataChanged) {
        onlyUpdatedData.push(data);
      }
    });
    const weeklyUpdatedObj = onlyUpdatedData.map((row) => {
      return weeklyUpdatedData(row);
    });

    if (weeklyUpdatedObj.length === 0) {
      showMessage("No changes made to the records", "info");
      return;
    }

    //console.log(weeklyUpdatedObj);

    let modificationObj = {
      approvedRejectedBy: ModifiedList?.approvedRejectedBy,
      comments: mainComments,
      commentsNew: mainComments, //send through this
      countryid: selectedCountryID,
      countryName: selectedCountry,
      depletionModel: ModifiedList?.depletionModel,
      isFullOrder: false,
      isModified: ModifiedList?.isModified,
      isStickToQuota: false,
      modificationID: ModifiedList?.modificationID,
      orderStatus: "Blocked",
      quotaCusumptionCustomers: [],
      quotaCusumptionCustomers2: weeklyUpdatedObj,
      quotaID: ModifiedList?.quotaID,
      quotaModificationFiles: ModifiedList.quotaModificationFiles,
      rejectionComments: ModifiedList?.rejectionComments,
      scenarioID: selectedScenarioID,
      scenarioName: selectedScenario,
      sentToSAPFlag: ModifiedList?.sentToSAPFlag,
      status: ModifiedList?.status,
      updateDate: ModifiedList?.updateDate,
      updatedBy: ModifiedList?.updatedBy,
      user: userData,
    };

    //console.log(modificationObj);
    dispatch(SubmitModification(modificationObj)).then(() => {
      dispatch(reset("clear"));
      const obj = {
        countryID: selectedCountryID,
        orderStatus: selectedOrderStatus,
        searchText: searchTxt,
        period: selectedPeriod,
      };
      dispatch(GetScenarios(obj));
      dispatch(setState("clearQCTable", true));
      dispatch(setState("clearMTable", true));
      dispatch(setState("clearReviewTable", true));
    });
  };

  useEffect(() => {
    if (
      onUnblockClickedSubmitted &&
      modificationId !== null &&
      modificationId !== 0
    ) {
      if (onUnblockClicked) {
        let obj = {
          scenarioId: selectedScenarioID,
          CountryId: getScenarios.find(
            (x) => x.scenarioID === selectedScenarioID
          ).geoID,
          modificationId: modificationId,
          DecisionCode: "UB",
          Quotaid: getQuotaDetails.quotaID,
          UserId: JSON.parse(localStorage.getItem("data")).userID,
          customer: customerListForDecisionSubmission,
        };
        dispatch(UnblockFullOrderMSQ(obj));
      } else if (onMSQClicked) {
        let obj = {
          scenarioId: selectedScenarioID,
          CountryId: getScenarios.find(
            (x) => x.scenarioID === selectedScenarioID
          ).geoID,
          modificationId: modificationId,
          DecisionCode: "MSQ",
          Quotaid: getQuotaDetails.quotaID,
          UserId: JSON.parse(localStorage.getItem("data")).userID,
          customer: customerListForDecisionSubmission,
        };
        dispatch(UnblockFullOrderMSQ(obj));
      }
    }
    dispatch(setState("onUnblockClickedSubmitted", false));
  }, [modificationId]);

  // useEffect(() => {
  //     // var totalQuotaVal = getQuotaDetails?.quotaCusumptionCustomers.reduce((acc, o) => acc + parseInt(o.quota), 0)

  //     // //var totalRevisedQuota = rows.reduce((acc, o) => acc + parseInt(o.weekly5), 0)

  //     // setTotalQuota(totalQuotaVal);
  //     // //dispatch(setState("totalRevisedQuota", totalRevisedQuota));
  //     // //dispatch(setState("difference", difference));
  //     // setRevisedQuota(totalQuotaVal);
  // }, [])

  useEffect(() => {
    if (checkedCustomersList?.length > 0) {
      if (isModifyClicked) {
        setRowSelectionModel(checkedCustomersList);
        dispatch(setState("isModifyClicked", false));
        setIsOnlySelectedCustomers(false);
      }
    }
  }, [rows]);

  useEffect(() => {
    setIsOnlySelectedCustomers(false);
    if (checkedCustomersList?.length > 0) {
      setRowSelectionModel(checkedCustomersList);
      setUpdatedRowIds([]);
    } else {
      setRowSelectionModel([]);
      setUpdatedRowIds([]);
    }
    if(isModifyClicked){
      debugger;
      setcustomerType([]);
      setcustomerTrustLvl([]);
      dispatch(setState("isModifyClicked", false));
      if(searchProduct === undefined)setSearchProduct("");
      if(searchCustomer === undefined)setSearchCustomer("");
      //setRows(modifyList);
      if(isOnlySelectedCustomers){
        setRows((prevVal) => {
          let val = modifyList?.filter((item) => {
            let retVal = false;
            if (rowSelectionModel !== undefined) {
              retVal = rowSelectionModel.includes(item.customerQuotaID);
            } else {
              return retVal;
            }
            return retVal;
          });
          return val;
        });
      }else if(isDisplayBlocked){
        filterSetRow(modifyList);
      }else{
        setRows(modifyList);
      }
      setSearchCustomer(CustomerSearchTxt);
      setSearchProduct(ProductSearchTxt);
      scrollToThirdDataGrid();
    }
  }, [isModifyClicked]);

  useEffect(() => {
    // if((isSelectAllForModify && IsModifyClicked) || isDisplayBlocked ){
    //     if (quotaConsumptionTableState?.length > 0) {

    //         setRows(quotaConsumptionTableState);
    //     }
    // }else{
    //     setRows(getQuotaDetails.quotaCusumptionCustomers)
    // }
    // dispatch(setState("IsModifyClicked", false));
    if (modifyList?.length > 0) {
      if(searchProduct === undefined)setSearchProduct("");
      if(searchCustomer === undefined)setSearchCustomer("");
      setcustomerType([]);
      setcustomerTrustLvl([]);
      //setRows(modifyList);
      if(isOnlySelectedCustomers){
        setRows((prevVal) => {
          let val = modifyList?.filter((item) => {
            let retVal = false;
            if (rowSelectionModel !== undefined) {
              retVal = rowSelectionModel.includes(item.customerQuotaID);
            } else {
              return retVal;
            }
            return retVal;
          });
          return val;
        });
      }else if(isDisplayBlocked){
        filterSetRow(modifyList);
      }else{
        setRows(modifyList);
      }
      setSearchCustomer(CustomerSearchTxt);
      setSearchProduct(ProductSearchTxt);
      setIsDisplayBlockedCustomers(isDisplayBlocked);
    }
    if(isModifyClicked){
      scrollToThirdDataGrid();
    }
  }, [modifyList]);

  const filterSetRow = (List) =>{
    debugger;
    setRows((prevVal) => {
      let val = List?.filter((item) => {
        let retVal = false;
        retVal =  (item.orderStatus.toLowerCase().includes("blocked") || item.customerName.toLowerCase().includes("buffer"))  &&
        (item.customerName
          .toLowerCase()
          .includes(searchCustomer.toLowerCase()) ||
          item.sapCustomerNumber
            .toLowerCase()
            .includes(searchCustomer.toLowerCase())) &&
        (item.skuName
          .toLowerCase()
          .includes(searchProduct?.toLowerCase()) ||
          item.skuNumb
            .toLowerCase()
            .includes(searchProduct?.toLowerCase()));
        return retVal;
      });
      return val;
    });
  }

  //console.log(quotaConsumptionTableState);

  useEffect(() => {
    let upRow = [...new Set([...rowSelectionModel, ...updatedRowIds])];
    setRowSelectionModel(upRow);
    IsValidIntendedQuantity();
  }, [updatedWeeklyData]);
  useEffect(() => {
    if ((onUnblockClicked || onMSQClicked) && isCurrentWeekRowChanged) {
      setUnblockMSQDecision();
    }
  }, [isCurrentWeekRowChanged]);
  const setUnblockMSQDecision = () => {
    if (customerListForDecisionSubmission?.length > 0) {
      let customerList = [];
      let customerListDecision = JSON.parse(
        JSON.stringify(customerListForDecisionSubmission)
      );
      for (let i = 0; i < selectedCustomersForDecision.length; i++) {
        const row = ModifiedList.quotaCusumptionCustomers.find(
          (row) => row.customerQuotaID === selectedCustomersForDecision[i]
        );
        if (row["orderStatus"].toLowerCase() == "blocked") {
          customerList.push(row.customerQuotaID);
        }
      }
      let quotaDetailslist = JSON.parse(JSON.stringify(ModifiedList));
      quotaDetailslist.quotaCusumptionCustomers = JSON.parse(
        JSON.stringify(updatedWeeklyData)
      );
      let idxs = -1;
      for (let i = 0; i < customerList.length; i++) {
        let details = {};
        for (let j = 0; j < customerListForDecisionSubmission.length; j++) {
          let Ind = customerListForDecisionSubmission[j].details.findIndex(
            (x) => Number(x.customerQuotaId) === Number(customerList[i])
          );
          if (Ind > -1) {
            details = customerListForDecisionSubmission[j].details[Ind];
            idxs = j;
            break;
          }
        }
        let packSize = Number(details.packSize);
        let idx = quotaDetailslist.quotaCusumptionCustomers.findIndex(
          (x) => x.customerQuotaID === Number(customerList[i])
        );
        let quota = 0;
        if (currentWeek === 1)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly1;
        if (currentWeek === 2)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly2;
        if (currentWeek === 3)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly3;
        if (currentWeek === 4)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly4;
        if (currentWeek === 5)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly5;

        let availableQuota =
          quota - quotaDetailslist.quotaCusumptionCustomers[idx].consumption;
        //quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM =availableQuota;
        let detailedOrders = customerListDecision[idxs].details.filter(
          (x) => Number(x.customerQuotaId) === Number(customerList[i]) && x.isBlocked.toLowerCase() === 'yes'
        );
        let IntendedQuantity = 
        detailedOrders.reduce((sum, item) => sum + Number(item.intendedQtyUoM), 0);
        // let NotBlocked = detailedOrders.filter(item=> item.isBlocked === 'No');
        // if(NotBlocked.length > 0) {
        //   let NotBlockedCustomersConsumtion = 
        //   detailedOrders.filter(item => item.isBlocked === 'No').reduce((sum, item) => sum + Number(item.availableQuota), 0);
        //   availableQuota = quota -  quotaDetailslist.quotaCusumptionCustomers[idx].consumption + NotBlockedCustomersConsumtion;
        //   //quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM  = AvQuotaForCal;
        // }
        for (let i = 0; i < detailedOrders.length; i++) {
          let Ratio =
            Number(detailedOrders[i].intendedQtyUoM) /
            (IntendedQuantity);
          detailedOrders[i].intendedQtyPacks = Math.round(detailedOrders[i].intendedQtyUoM/detailedOrders[i].packSize);
          detailedOrders[i].modifiedQtyUoM = Math.round(availableQuota * Ratio);
          detailedOrders[i].modifiedQtyPacks = Math.round(detailedOrders[i].modifiedQtyUoM / detailedOrders[i].packSize);
          detailedOrders[i].modifiedQtyUoM = Math.ceil(detailedOrders[i].modifiedQtyPacks *
            detailedOrders[i].packSize);
        }
        let sumModifiedQuantity = detailedOrders.reduce((sum, item) => sum + Number(item.modifiedQtyUoM), 0);
        quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM = sumModifiedQuantity;
      }
      dispatch(setState("ModifiedList", quotaDetailslist));
      if(searchProduct === undefined)setSearchProduct("");
      if(searchCustomer === undefined)setSearchCustomer("");
      if(isOnlySelectedCustomers){
        setRows((prevVal) => {
          let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
            let retVal = false;
            if (rowSelectionModel !== undefined) {
              retVal = rowSelectionModel.includes(item.customerQuotaID) &&
              (item.customerName
                .toLowerCase()
                .includes(searchCustomer.toLowerCase()) ||
                item.sapCustomerNumber
                  .toLowerCase()
                  .includes(searchCustomer.toLowerCase())) &&
              (item.skuName
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()) ||
                item.skuNumb
                  .toLowerCase()
                  .includes(searchProduct?.toLowerCase()));
            } else {
              return retVal;
            }
            return retVal;
          });
          return val;
        });
      }else if(isDisplayBlockedCustomers){
        setRows((prevVal) => {
          let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
            let retVal = false;
            retVal =  (item.orderStatus.toLowerCase().includes("blocked") || item.customerName.toLowerCase().includes("buffer")) &&
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
            return retVal;
          });
          return val;
        });
      }
      else{
        setRows(ModifiedList.quotaCusumptionCustomers);
      }
      dispatch(
        setState(
          "updatedWeeklyData",
          quotaDetailslist?.quotaCusumptionCustomers
        )
      );
      dispatch(setState("isCurrentWeekRowChanged", false));
      dispatch(
        setState("customerListForDecisionSubmission", customerListDecision)
      );
    }
  };
  const IsValidIntendedQuantity = () => {
    let isValid = true;
    for(let i = 0; i< ModifiedList.quotaCusumptionCustomers.length; i++){
      if(Number(ModifiedList.quotaCusumptionCustomers[i].intendedQuantity)
       < Number(ModifiedList.quotaCusumptionCustomers[i].modifiedOrderQtyUoM)){
        showMessage("Intended quantity should not be less than modifiedOrderQtyUoM value.", "error");
        isValid = false;
        break;
      }
    }
    return isValid;
  };
  const IsValid = () => {
    let isValid = true;
    for(let i = 0; i< ModifiedList.quotaCusumptionCustomers.length; i++){
      if(Number(ModifiedList.quotaCusumptionCustomers[i].intendedQuantity)
       < Number(ModifiedList.quotaCusumptionCustomers[i].modifiedOrderQtyUoM)){
        showMessage("Intended quantity should not be less than modifiedOrderQtyUoM value.", "error");
        isValid = false;
        break;
      }
    }
    if(isValid){
      for (let i = 0; i < updatedWeeklyData.length; i++) {
        if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
          if (
            updatedWeeklyData[i].newFinalQuota.weekly1 <
            updatedWeeklyData[i].consumption
          ) {
            showMessage(
              "Quota value should not be less than Consumption value.",
              "error"
            );
            isValid = false;
            break;
          }
        } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
          if (
            updatedWeeklyData[i].newFinalQuota.weekly1 >
            updatedWeeklyData[i].newFinalQuota.weekly2
          ) {
            showMessage(
              "Quota value for weeks ahead of Week 1 should be greater than Week 1 value.",
              "error"
            );
            isValid = false;
            break;
          }
          if (
            updatedWeeklyData[i].newFinalQuota.weekly2 <
              updatedWeeklyData[i].consumption ||
            (getWeekStatus.chkFirstHalf &&
              updatedWeeklyData[i].newFinalQuota.weekly1 <
                updatedWeeklyData[i].consumption)
          ) {
            showMessage(
              "Quota value should not be less than Consumption value.",
              "error"
            );
            isValid = false;
            break;
          }
        } else {
          if (
              getWeekStatus.chkWeek1 && (
              updatedWeeklyData[i].newFinalQuota.weekly2 <
                updatedWeeklyData[i].newFinalQuota.weekly1 ||
              updatedWeeklyData[i].newFinalQuota.weekly3 < 
                updatedWeeklyData[i].newFinalQuota.weekly2 || 
              updatedWeeklyData[i].newFinalQuota.weekly4 < 
                updatedWeeklyData[i].newFinalQuota.weekly3 || 
              updatedWeeklyData[i].newFinalQuota.weekly5 < 
                updatedWeeklyData[i].newFinalQuota.weekly4
              )
          ) {
            showMessage(
              "Quota value for weeks ahead of Week 1 should be greater than Week 1 value.",
              "error"
            );
            isValid = false;
            break;
          }
          if (
            getWeekStatus.chkWeek2 && (
              updatedWeeklyData[i].newFinalQuota.weekly3 < 
                updatedWeeklyData[i].newFinalQuota.weekly2 || 
              updatedWeeklyData[i].newFinalQuota.weekly4 < 
                updatedWeeklyData[i].newFinalQuota.weekly3 || 
              updatedWeeklyData[i].newFinalQuota.weekly5 < 
                updatedWeeklyData[i].newFinalQuota.weekly4
            )
          ) {
            showMessage(
              "Quota value for weeks ahead of Week 2 should be greater than Week 2 value.",
              "error"
            );
            isValid = false;
            break;
          }
          if (
            getWeekStatus.chkWeek3 && (
            updatedWeeklyData[i].newFinalQuota.weekly4 < 
              updatedWeeklyData[i].newFinalQuota.weekly3 || 
            updatedWeeklyData[i].newFinalQuota.weekly5 < 
              updatedWeeklyData[i].newFinalQuota.weekly4
            )

          ) {
            showMessage(
              "Quota value for weeks ahead of Week 3 should be greater than Week 3 value.",
              "error"
            );
            isValid = false;
            break;
          }
          if (
            getWeekStatus.chkWeek4 && (
            updatedWeeklyData[i].newFinalQuota.weekly5 < 
              updatedWeeklyData[i].newFinalQuota.weekly4
            )
          ) {
            showMessage(
              "Week 5 Quota should be greater than previous Week Quota.",
              "error"
            );
            isValid = false;
            break;
          }
          if (
            updatedWeeklyData[i].newFinalQuota.weekly5 <
              updatedWeeklyData[i].consumption ||
            (getWeekStatus.chkWeek4 &&
              updatedWeeklyData[i].newFinalQuota.weekly4 <
                updatedWeeklyData[i].consumption) ||
            (getWeekStatus.chkWeek3 &&
              updatedWeeklyData[i].newFinalQuota.weekly3 <
                updatedWeeklyData[i].consumption) ||
            (getWeekStatus.chkWeek2 &&
              updatedWeeklyData[i].newFinalQuota.weekly2 <
                updatedWeeklyData[i].consumption) ||
            (getWeekStatus.chkWeek1 &&
              updatedWeeklyData[i].newFinalQuota.weekly1 <
                updatedWeeklyData[i].consumption)
          ) {
            showMessage(
              "Quota value should not be less than Consumption value.",
              "error"
            );
            isValid = false;
            break;
          }
        }
      }
    }
    return isValid;
  };
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  const handleOnCustomerProductChange = (selectCustomer, selectProduct) => {
    if(searchProduct === undefined)setSearchProduct("");
    if(searchCustomer === undefined)setSearchCustomer("");
    filteredRow();
  };

  useEffect(()=>{
    filteredRow();
  },[customerType, customerTrustLvl])

  useEffect(() => {
    handleOnCustomerProductChange(searchCustomer, searchProduct);
  }, [searchCustomer]);

  useEffect(() => {
    handleOnCustomerProductChange(searchCustomer, searchProduct);
  }, [searchProduct]);

  useEffect(() => {
    if (isDisplayBlockedCustomers) {
      setIsOnlySelectedCustomers(false);
      setcustomerType([]);
      setcustomerTrustLvl([]);
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          if (isDisplayBlockedCustomers !== undefined) {
            if(searchProduct === undefined)setSearchProduct("");
            if(searchCustomer === undefined)setSearchCustomer("");
            retVal = (item.orderStatus.toLowerCase().includes("blocked") || item.customerName.toLowerCase().includes("buffer")) &&
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
          } else {
            return retVal;
          }
          return retVal;
        });
        return val;
      });
    }else {
      setRows((prevVal) => {
        setIsOnlySelectedCustomers(false);
        setcustomerType([]);
        setcustomerTrustLvl([]);
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          retVal =
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
          return retVal;
        });
        return val;
      });
    }
    if(isModifyClicked){
      scrollToThirdDataGrid();
    }
  }, [isDisplayBlockedCustomers]);
  useEffect(()=>{
    setIsDisplayBlockedCustomers(isDisplayBlocked);
  },[isDisplayBlocked])
  const handleIsOnlySelected = (e) => {
    setIsOnlySelectedCustomers(e.target.checked);
    if(searchProduct === undefined)setSearchProduct("");
    if(searchCustomer === undefined)setSearchCustomer("");
  };

  const filteredRow = (RowList) =>{
    if (isOnlySelectedCustomers) {
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          if (rowSelectionModel !== undefined) {
            retVal =
            (customerType.length === 0 || customerType.some(type => item.customerType.toLowerCase().includes(type.toLowerCase()))) &&
            (customerTrustLvl.length === 0 || customerTrustLvl.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
            rowSelectionModel.includes(item.customerQuotaID) &&
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
          } else {
            return retVal;
          }
          return retVal;
        });
        return val;
      });
    }else if(isDisplayBlockedCustomers){
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
            retVal =
            (customerType.length === 0 || customerType.some(type => item.customerType.toLowerCase().includes(type.toLowerCase()))) &&
            (customerTrustLvl.length === 0 || customerTrustLvl.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
            (item.orderStatus.toLowerCase().includes("blocked") || item.customerName.toLowerCase().includes("buffer")) &&
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
          return retVal;
        });
        return val;
      });
    } else {
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          retVal =
            (customerType.length === 0 || customerType.some(type => item.customerType.toLowerCase().includes(type.toLowerCase()))) &&
            (customerTrustLvl.length === 0 || customerTrustLvl.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
            return retVal;
        });
        return val;
      });
    }
  }
  useEffect(() =>{
      if(searchProduct === undefined)setSearchProduct("");
      if(searchCustomer === undefined)setSearchCustomer("");
      filteredRow();
  },[isOnlySelectedCustomers]);
  useEffect(() => {
    if (selectedWeeklyData.length > 0) {
      let result = selectedWeeklyData?.map((x) => x.customerQuotaID);
      //console.log(result);
      setRowSelectionModel(result);
    }
  }, [selectedWeeklyData]);

  const weeklyUpdatedData = (obj) => {
    let resultObj = {
      customerComments: obj.customerComments,
      customerGroupID: obj.customerGroupID,
      customerID: obj.customerID,
      customerQuotaID: obj.customerQuotaID,
      orderStatus: obj.orderStatus,
      productGroupID: obj.productGroupID,
      skuid: obj.skuid,
      weekly1: parseInt(obj.newFinalQuota.weekly1),
      weekly2: parseInt(obj.newFinalQuota.weekly2),
      weekly3: parseInt(obj.newFinalQuota.weekly3),
      weekly4: parseInt(obj.newFinalQuota.weekly4),
      weekly5: parseInt(obj.newFinalQuota.weekly5),
    };

    return resultObj;
  };

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const handleOverallModification = () => {
    dispatch(setState("isLoading", true));
    const timeout = setTimeout(() => {
    const currentState = _.cloneDeep(updatedWeeklyData);

    if (isCheckedHeader.isCheckedWeekly1) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (modificationPercentage != "") {
            let val = item.newFinalQuota.weekly1;
            item.newFinalQuota.weekly1 = Math.round(
              val + (val / 100) * parseInt(modificationPercentage)
            );
            item.deltaModification.weekly1 =
              item.newFinalQuota.weekly1 - item.lastApproved.weekly1;
          }
        }
      });
    }

    if (isCheckedHeader.isCheckedWeekly2) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (modificationPercentage != "") {
            let val = item.newFinalQuota.weekly2;
            item.newFinalQuota.weekly2 = Math.round(
              val + (val / 100) * parseInt(modificationPercentage)
            );
            item.deltaModification.weekly2 =
              item.newFinalQuota.weekly2 - item.lastApproved.weekly2;
          }
        }
      });
    }

    if (isCheckedHeader.isCheckedWeekly3) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (modificationPercentage != "") {
            let val = item.newFinalQuota.weekly3;
            item.newFinalQuota.weekly3 = Math.round(
              val + (val / 100) * parseInt(modificationPercentage)
            );
            item.deltaModification.weekly3 =
              item.newFinalQuota.weekly3 - item.lastApproved.weekly3;
          }
        }
      });
    }

    if (isCheckedHeader.isCheckedWeekly4) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (modificationPercentage != "") {
            let val = item.newFinalQuota.weekly4;
            item.newFinalQuota.weekly4 = Math.round(
              val + (val / 100) * parseInt(modificationPercentage)
            );
            item.deltaModification.weekly4 =
              item.newFinalQuota.weekly4 - item.lastApproved.weekly4;
          }
        }
      });
    }

    if (isCheckedHeader.isCheckedWeekly5) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (modificationPercentage != "") {
            let val = item.newFinalQuota.weekly5;
            item.newFinalQuota.weekly5 = Math.round(
              val + (val / 100) * parseInt(modificationPercentage)
            );
            item.deltaModification.weekly5 =
              item.newFinalQuota.weekly5 - item.lastApproved.weekly5;
          }
        }
      });
    }

    rowSelectionModel.forEach((id) => {
      getUpdatedRowIds(id);
    });

    dispatch(setState("updatedWeeklyData", currentState));
    dispatch(setState("isLoading", false));
  },1);
  };

  const handleRounder = () => {
    dispatch(setState("isLoading", true));
    const timer = setTimeout(() => {
    const currentState = _.cloneDeep(updatedWeeklyData);

    if (isCheckedHeader.isCheckedWeekly1) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (rounder != "") {
            let val = item.newFinalQuota.weekly1;
            item.newFinalQuota.weekly1 =
              parseInt(rounder) * Math.round(val / parseInt(rounder));
            item.deltaModification.weekly1 =
              item.newFinalQuota.weekly1 - item.lastApproved.weekly1;
          }
        }
      });
    }

    if (isCheckedHeader.isCheckedWeekly2) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (rounder != "") {
            let val = item.newFinalQuota.weekly2;
            item.newFinalQuota.weekly2 =
              parseInt(rounder) * Math.round(val / parseInt(rounder));
            item.deltaModification.weekly2 =
              item.newFinalQuota.weekly2 - item.lastApproved.weekly2;
          }
        }
      });
    }

    if (isCheckedHeader.isCheckedWeekly3) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (rounder != "") {
            let val = item.newFinalQuota.weekly3;
            item.newFinalQuota.weekly3 =
              parseInt(rounder) * Math.round(val / parseInt(rounder));
            item.deltaModification.weekly3 =
              item.newFinalQuota.weekly3 - item.lastApproved.weekly3;
          }
        }
      });
    }

    if (isCheckedHeader.isCheckedWeekly4) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (rounder != "") {
            let val = item.newFinalQuota.weekly4;
            item.newFinalQuota.weekly4 =
              parseInt(rounder) * Math.round(val / parseInt(rounder));
            item.deltaModification.weekly4 =
              item.newFinalQuota.weekly4 - item.lastApproved.weekly4;
          }
        }
      });
    }

    if (isCheckedHeader.isCheckedWeekly5) {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          if (rounder != "") {
            let val = item.newFinalQuota.weekly5;
            item.newFinalQuota.weekly5 =
              parseInt(rounder) * Math.round(val / parseInt(rounder));
            item.deltaModification.weekly5 =
              item.newFinalQuota.weekly5 - item.lastApproved.weekly5;
          }
        }
      });
    }

    rowSelectionModel.forEach((id) => {
      getUpdatedRowIds(id);
    });
    //console.log(currentState);
    dispatch(setState("updatedWeeklyData", currentState));
    dispatch(setState("isLoading", false));
  },1);
  };

  const pullForwardQuota = async () => {
    const currentState = _.cloneDeep(updatedWeeklyData);
    if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
      return;
    } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          item.newFinalQuota.weekly1 = item.newFinalQuota.weekly2;
          item.deltaModification.weekly1 =
            item.newFinalQuota.weekly1 - item.lastApproved.weekly1;
        }
      });
    } else {
      currentState.forEach((item) => {
        if (rowSelectionModel.includes(item.customerQuotaID)) {
          item.newFinalQuota.weekly1 = item.newFinalQuota.weekly5;
          item.newFinalQuota.weekly2 = item.newFinalQuota.weekly5;
          item.newFinalQuota.weekly3 = item.newFinalQuota.weekly5;
          item.newFinalQuota.weekly4 = item.newFinalQuota.weekly5;
          item.deltaModification.weekly1 =
            item.newFinalQuota.weekly1 - item.lastApproved.weekly1;
          item.deltaModification.weekly2 =
            item.newFinalQuota.weekly2 - item.lastApproved.weekly2;
          item.deltaModification.weekly3 =
            item.newFinalQuota.weekly3 - item.lastApproved.weekly3;
          item.deltaModification.weekly4 =
            item.newFinalQuota.weekly4 - item.lastApproved.weekly4;
        }
      });
    }

    rowSelectionModel.forEach((id) => {
      getUpdatedRowIds(id);
    });
    //console.log(currentState);

    dispatch(setState("updatedWeeklyData", currentState));
  };

  //console.log(weeklyPullForward)

  useEffect(() => {
    if (selectedValues.length === 0) {
      setRows([]);
    } else {
      //setRows(quotaConsumptionTableState);
      filteredRow();
    }
    if(isModifyClicked){
      scrollToThirdDataGrid();
    }
  }, [selectedValues]);

  //const visibleColumns = columns.filter((col) => !hideColumns(props.row.id).includes(col.field));
  let visibleColumns = [];

  let arr = ["weekly2", "weekly3", "weekly4", "weekly5"];
  if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
    visibleColumns = columns.filter(
      (col) =>
        col.field !== "weekly2" &&
        col.field !== "weekly3" &&
        col.field !== "weekly4" &&
        col.field !== "weekly5"
    );
  } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
    visibleColumns = columns.filter(
      (col) =>
        col.field !== "weekly3" &&
        col.field !== "weekly4" &&
        col.field !== "weekly5"
    );
  } else {
    visibleColumns = columns;
  }

  let getTotalQuotaCM = updatedWeeklyData?.reduce(
    (acc, obj) => acc + obj.quota,
    0
  );
  let modifiedQuotaCM = 0;
  if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
    modifiedQuotaCM = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.newFinalQuota.weekly1,
      0
    );
  } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
    modifiedQuotaCM = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.newFinalQuota.weekly2,
      0
    );
  } else {
    modifiedQuotaCM = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.newFinalQuota.weekly5,
      0
    );
  }
  let differenceCM =
    modifiedQuotaCM - getTotalQuotaCM < 0
      ? getTotalQuotaCM - modifiedQuotaCM
      : modifiedQuotaCM - getTotalQuotaCM;
  let differenceCMPerc = (differenceCM / getTotalQuotaCM) * 100;
  differenceCMPerc = differenceCMPerc.toFixed(0);

  let getTotalQuotaAQ = 0;
  if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
    getTotalQuotaAQ = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.initialQuota.weekly1,
      0
    );
  } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
    getTotalQuotaAQ = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.initialQuota.weekly2,
      0
    );
  } else {
    getTotalQuotaAQ = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.initialQuota.weekly5,
      0
    );
  }
  let modifiedQuotaAQ = 0;
  if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
    modifiedQuotaAQ = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.newFinalQuota.weekly1,
      0
    );
  } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
    modifiedQuotaAQ = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.newFinalQuota.weekly2,
      0
    );
  } else {
    modifiedQuotaAQ = updatedWeeklyData?.reduce(
      (acc, obj) => acc + obj.newFinalQuota.weekly5,
      0
    );
  }
  let differenceAQ =
    modifiedQuotaAQ - getTotalQuotaAQ < 0
      ? getTotalQuotaAQ - modifiedQuotaAQ
      : modifiedQuotaAQ - getTotalQuotaAQ;
  let differenceAQPerc = (differenceAQ / getTotalQuotaAQ) * 100;
  differenceAQPerc = differenceAQPerc.toFixed(0);

  const handleExportFile = () => {
    let quotaConsumptionScenario = {};
    quotaConsumptionScenario.countryName = selectedCountry;
    quotaConsumptionScenario.countryid = selectedCountryID;
    quotaConsumptionScenario.depletionModel = ModifiedList?.depletionModel;
    quotaConsumptionScenario.quotaCusumptionCustomers =
      ModifiedList?.quotaCusumptionCustomers;
    quotaConsumptionScenario.scenarioID = selectedScenarioID;
    quotaConsumptionScenario.scenarioName = selectedScenario;

    let obj = {
      period: selectedPeriod === 0 ? "Previous" : "Current",
      quotaConsumptionScenario: quotaConsumptionScenario,
      weeks: getWeekStatus,
    };

    dispatch(ExportExcel(obj));
  };

  const handleSelectFile = (file) => {
    setUploadedFile(file);
  };

  const handleDelete = () => {
    setUploadedFile(null);
  };

  const handleImportFile = () => {
    const formData = new FormData();
    formData.append("files", uploadedFile, uploadedFile.name);
    formData.append("country", selectedCountry);
    formData.append("scenario", selectedScenario);
    formData.append("weeklyDepletion", ModifiedList?.depletionModel);
    // let obj = {
    //   scenarioName: selectedScenario,
    //   countryName: selectedCountry,
    //   depletion: ModifiedList?.depletionModel,
    //   formData: formData,
    // };
    dispatch(ImportExcel(formData));
    setUploadedFile(null);
  };
  useEffect(() => {
    let currentState = _.cloneDeep(updatedWeeklyData);
    const updatedCustomerQuota = [];
    const updatedCustomerQuotaIds = [];

    // Compare the objects based on specific fields (e.g., 'Weekly1', 'weekly1', and 'weekly2')
    excelData?.quotaCusumptionCustomers?.forEach((obj2) => {
      const obj1 = updatedWeeklyData?.find(
        (o) => o.customerQuotaID === obj2.customerQuotaID
      );
      if (obj1) {
        const weekly1Changed =
          obj1.lastApproved.weekly1 !== obj2.weekly1 ;
        const weekly2Changed =
          obj1.lastApproved.weekly2 !== obj2.weekly2 ;
        const weekly3Changed =
          obj1.lastApproved.weekly3 !== obj2.weekly3 ;
        const weekly4Changed =
          obj1.lastApproved.weekly4 !== obj2.weekly4 ;
        const weekly5Changed =
          obj1.lastApproved.weekly5 !== obj2.weekly5 ;
        const CommentsChanged = obj1.customerComments !== obj2.customerComments;

        if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
          if (weekly1Changed) {
            updatedCustomerQuota.push(obj2);
            updatedCustomerQuotaIds.push(obj2.customerQuotaID);
          }
        } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
          if (
            (weekly1Changed && getWeekStatus.chkFirstHalf) ||
            (weekly2Changed && getWeekStatus.chkSecondHalf) ||
            CommentsChanged
          ) {
            updatedCustomerQuota.push(obj2);
            updatedCustomerQuotaIds.push(obj2.customerQuotaID);
          }
        } else {
          if (
            (weekly1Changed && getWeekStatus.chkWeek1) ||
            (weekly2Changed && getWeekStatus.chkWeek2) ||
            (weekly3Changed && getWeekStatus.chkWeek3) ||
            (weekly4Changed && getWeekStatus.chkWeek4) ||
            (weekly5Changed && getWeekStatus.chkWeek5) ||
            CommentsChanged
          ) {
            updatedCustomerQuota.push(obj2);
            updatedCustomerQuotaIds.push(obj2.customerQuotaID);
          }
        }
      }
    });

    currentState?.forEach((item) => {
      if (updatedCustomerQuotaIds.includes(item.customerQuotaID)) {
        if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
          item.newFinalQuota.weekly1 =
            updatedCustomerQuota.find(
              (o) => o.customerQuotaID === item.customerQuotaID
            ).weekly1 > 0
              ? updatedCustomerQuota.find(
                  (o) => o.customerQuotaID === item.customerQuotaID
                ).weekly1
              : 0;
          item.deltaModification.weekly1 =
            item.newFinalQuota.weekly1 - item.lastApproved.weekly1;
        } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
          if (getWeekStatus.chkFirstHalf) {
            item.newFinalQuota.weekly1 =
              updatedCustomerQuota.find(
                (o) => o.customerQuotaID === item.customerQuotaID
              ).weekly1 > 0
                ? updatedCustomerQuota.find(
                    (o) => o.customerQuotaID === item.customerQuotaID
                  ).weekly1
                : 0;
            item.deltaModification.weekly1 =
              item.newFinalQuota.weekly1 - item.lastApproved.weekly1;
          }
          if (getWeekStatus.chkSecondHalf) {
            item.newFinalQuota.weekly2 =
              updatedCustomerQuota.find(
                (o) => o.customerQuotaID === item.customerQuotaID
              ).weekly2 > 0
                ? updatedCustomerQuota.find(
                    (o) => o.customerQuotaID === item.customerQuotaID
                  ).weekly2
                : 0;
            item.deltaModification.weekly2 =
              item.newFinalQuota.weekly2 - item.lastApproved.weekly2;
          }
        } else {
          if (getWeekStatus.chkWeek1) {
            item.newFinalQuota.weekly1 =
              updatedCustomerQuota.find(
                (o) => o.customerQuotaID === item.customerQuotaID
              ).weekly1 > 0
                ? updatedCustomerQuota.find(
                    (o) => o.customerQuotaID === item.customerQuotaID
                  ).weekly1
                : 0;
            item.deltaModification.weekly1 =
              item.newFinalQuota.weekly1 - item.lastApproved.weekly1;
          }
          if (getWeekStatus.chkWeek2) {
            item.newFinalQuota.weekly2 =
              updatedCustomerQuota.find(
                (o) => o.customerQuotaID === item.customerQuotaID
              ).weekly2 > 0
                ? updatedCustomerQuota.find(
                    (o) => o.customerQuotaID === item.customerQuotaID
                  ).weekly2
                : 0;
            item.deltaModification.weekly2 =
              item.newFinalQuota.weekly2 - item.lastApproved.weekly2;
          }
          if (getWeekStatus.chkWeek3) {
            item.newFinalQuota.weekly3 =
              updatedCustomerQuota.find(
                (o) => o.customerQuotaID === item.customerQuotaID
              ).weekly3 > 0
                ? updatedCustomerQuota.find(
                    (o) => o.customerQuotaID === item.customerQuotaID
                  ).weekly3
                : 0;
            item.deltaModification.weekly3 =
              item.newFinalQuota.weekly3 - item.lastApproved.weekly3;
          }
          if (getWeekStatus.chkWeek4) {
            item.newFinalQuota.weekly4 =
              updatedCustomerQuota.find(
                (o) => o.customerQuotaID === item.customerQuotaID
              ).weekly4 > 0
                ? updatedCustomerQuota.find(
                    (o) => o.customerQuotaID === item.customerQuotaID
                  ).weekly4
                : 0;
            item.deltaModification.weekly4 =
              item.newFinalQuota.weekly4 - item.lastApproved.weekly4;
          }
          if (getWeekStatus.chkWeek5) {
            item.newFinalQuota.weekly5 =
              updatedCustomerQuota.find(
                (o) => o.customerQuotaID === item.customerQuotaID
              ).weekly5 > 0
                ? updatedCustomerQuota.find(
                    (o) => o.customerQuotaID === item.customerQuotaID
                  ).weekly5
                : 0;
            item.deltaModification.weekly5 =
              item.newFinalQuota.weekly5 - item.lastApproved.weekly5;
          }
        }
        item.customerComments = updatedCustomerQuota.find(
          (o) => o.customerQuotaID === item.customerQuotaID
        ).customerComments;
      }
    });
    //console.log(currentState);

    dispatch(setState("updatedWeeklyData", currentState));
    let updatedList = {
      ...ModifiedList,
      quotaCusumptionCustomers: currentState,
    };
    dispatch(setState("ModifiedList", updatedList));
    setExcelCustomerIds(updatedCustomerQuotaIds);
    let updatedComments = { ...userComments };
    currentState?.forEach((item) => {
      if (updatedCustomerQuotaIds.includes(item.customerQuotaID)) {
        updatedComments = {
          ...updatedComments,
          [item.customerQuotaID]: item.customerComments,
        };
      }
    });
    setUserComments(updatedComments);
    //console.log(updatedCustomerQuota);
  }, [excelData]);

  useEffect(() => {
    if (excelCustomerIds.length > 0) {
      setRowSelectionModel(excelCustomerIds);
      excelCustomerIds.forEach((id) => {
        getUpdatedRowIds(id);
      });
    }
  }, [excelCustomerIds]);
  //useEffect(() => {
  // Compare the weekly values for each object
  // const changedObjects = updatedWeeklyData?.filter(obj1 => {
  //   excelData?.quotaCusumptionCustomers?.forEach((obj2) => {
  //   return obj2 && (parseInt(obj1.initialQuota.weekly1) !== parseInt(obj2.weekly1) ||
  //   parseInt(obj1.initialQuota.weekly2) !== parseInt(obj2.weekly2) ||
  //   parseInt(obj1.initialQuota.weekly3) !== parseInt(obj2.weekly3)||
  //   parseInt(obj1.initialQuota.weekly4) !== parseInt(obj2.weekly4) ||
  //   parseInt(obj1.initialQuota.weekly5) !== parseInt(obj2.weekly5));
  //   })
  // });

  // Compare the objects based on specific fields (e.g., 'weekly1', 'weekly2', and 'weekly3')
  // const changedObjects = excelData?.quotaCusumptionCustomers.filter(obj2 => {
  //     const obj1 = updatedWeeklyData.filter(o => o.customerQuotaId === obj2.customerQuotaId);
  //     return obj1 && !_.isEqual(_.pick(obj1, ['weekly1', 'weekly2', 'weekly3','weekly4', 'weekly5']), _.pick(obj2, ['weekly1', 'weekly2', 'weekly3','weekly4', 'weekly5']));
  //   });

  //     setChangedCustomerIds(changedObjects);
  //   }, [updatedWeeklyData, excelData?.quotaCusumptionCustomers]);

  // Initialize an empty array to store updated customerQuotaIds

  // Print the updated customerQuotaIds

  // useEffect(() => {
  //     if (rowSelectionModel.length > 0) {
  //         rowSelectionModel.forEach((id) => {
  //             let val = apiRef.current.getCellValue(id, "customerComments")
  //             console.log(val);
  //         })
  //     }
  // }, [rowSelectionModel])

  // useEffect(() => {
  //     if (userComments !== null || userComments !== undefined) {

  //     }
  // }, [userComments])
  const handleDownloadFile = (filepath) => {
    dispatch(DownloadFile(filepath));
  };
  function handleInputClick() {
    inputRef.current.click();
  }

  function uploadFile(event) {
    const file = event.target.files[0];
    const obj = event.target.files[0];
    //console.log(file);
    dispatch(addFile(obj));
  }
  function handleDeleteFile(file) {
    //console.log(file);
    dispatch(deleteFile(file));
  }
  const getRowClassName = (params) => {
    if (updatedWeeklyData?.length === 0) return "";
    let item = updatedWeeklyData.filter(
      (o) => o.customerQuotaID === params.row.customerQuotaID
    );
    if (
      Number(params.row.intendedQuantity) <
      Number(params.row.modifiedOrderQtyUoM)
    ) {
      return "lightred-row";
    }
    if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
      if (item[0].newFinalQuota.weekly1 < item[0].consumption) {
        return "lightred-row";
      }
    } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
      if (item[0].newFinalQuota.weekly1 > item[0].newFinalQuota.weekly2) {
        return "lightred-row";
      }
      if (
        item[0].newFinalQuota.weekly2 < item[0].consumption ||
        (getWeekStatus.chkFirstHalf &&
          item[0].newFinalQuota.weekly1 < item[0].consumption)
      ) {
        return "lightred-row";
      }
    } else {
      if (
        getWeekStatus.chkWeek1 && (
          item[0].newFinalQuota.weekly2 < item[0].newFinalQuota.weekly1 ||
          item[0].newFinalQuota.weekly3 < item[0].newFinalQuota.weekly2 || 
          item[0].newFinalQuota.weekly4 < item[0].newFinalQuota.weekly3 || 
          item[0].newFinalQuota.weekly5 < item[0].newFinalQuota.weekly4
        )
      ) {
        return "lightred-row";
      }
      if (
        getWeekStatus.chkWeek2 && (
          item[0].newFinalQuota.weekly3 < item[0].newFinalQuota.weekly2 || 
          item[0].newFinalQuota.weekly4 < item[0].newFinalQuota.weekly3 || 
          item[0].newFinalQuota.weekly5 < item[0].newFinalQuota.weekly4
        )
      ) {
        return "lightred-row";
      }
      if (
        getWeekStatus.chkWeek3 && (
          item[0].newFinalQuota.weekly4 < item[0].newFinalQuota.weekly3 || 
          item[0].newFinalQuota.weekly5 < item[0].newFinalQuota.weekly4
        )
      ) {
        return "lightred-row";
      }
      if (
        getWeekStatus.chkWeek4 && (
          item[0].newFinalQuota.weekly5 < item[0].newFinalQuota.weekly4
        )
      ) {
        return "lightred-row";
      }
      if (
        item[0].newFinalQuota.weekly5 < item[0].consumption ||
        (getWeekStatus.chkWeek4 &&
          item[0].newFinalQuota.weekly4 < item[0].consumption) ||
        (getWeekStatus.chkWeek3 &&
          item[0].newFinalQuota.weekly3 < item[0].consumption) ||
        (getWeekStatus.chkWeek2 &&
          item[0].newFinalQuota.weekly2 < item[0].consumption) ||
        (getWeekStatus.chkWeek1 &&
          item[0].newFinalQuota.weekly1 < item[0].consumption)
      ) {
        return "lightred-row";
      }
    }
    if(params.row.isBlockedOverNormal === 1) {
      return "blockedOverNormal-row";
    }else if(params.row.isModified === 1){
      return "modified-row";
    }else{
      return "";
    }
    
  };

  return (
    <div>
      <Box m={2}>
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        {/* <Box className="scenario-search"> */}
        {/* <Grid container columns={12} justifyContent="space-between" alignItems="center" spacing={2} pb={1}>

                </Grid> */}

        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>

        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid
            item
            container
            direction="column"
            xs={12}
            sm={3.1}
            md={3.1}
            lg={3.1}
            spacing={2}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="subtitle1" my={2}>
                Scenario of : {selectedScenario}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="Search Customer"
                value={searchCustomer}
                onChange={handleSearchCustomer}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
                fullWidth
                size="small"
              ></TextField>
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="Search Product"
                value={searchProduct}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
                onChange={handleSearchProduct}
                fullWidth
                size="small"
              ></TextField>
            </Grid>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sm={8.8}
            md={8.8}
            lg={8.8}
            sx={{ mt: 1.5 }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <Box ref={ModRef}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow
                        sx={{
                          "& th": {
                            color: "#007DC3",
                            backgroundColor: "rgba(245, 246, 250)",
                          },
                        }}
                      >
                        <TableCell></TableCell>
                        <TableCell align="left">
                          <strong>Total Quota</strong>
                        </TableCell>
                        <TableCell align="left">
                          <strong>Total Mod. Quota</strong>
                        </TableCell>
                        <TableCell align="left">
                          <strong>Absolute Difference</strong>
                        </TableCell>
                        <TableCell align="left">
                          <strong>% Difference</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* {rows.map((row) => ( */}
                      <TableRow
                        key={"LQuota"}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {"Changed vs Last Modified Quota"}
                        </TableCell>
                        <TableCell align="left">{getTotalQuotaCM?.toLocaleString()}</TableCell>
                        <TableCell align="left">{modifiedQuotaCM?.toLocaleString()}</TableCell>
                        <TableCell align="left">{differenceCM?.toLocaleString()}</TableCell>
                        <TableCell align="left">{differenceCMPerc}</TableCell>
                      </TableRow>

                      <TableRow
                        key={"LModQuota"}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {"Changed vs 1st Approved Quota"}
                        </TableCell>
                        <TableCell align="left">{getTotalQuotaAQ?.toLocaleString()}</TableCell>
                        <TableCell align="left">{modifiedQuotaAQ?.toLocaleString()}</TableCell>
                        <TableCell align="left">{differenceAQ?.toLocaleString()}</TableCell>
                        <TableCell align="left">{differenceAQPerc}</TableCell>
                      </TableRow>
                      {/* ))} */}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Box mt={-1}>
        <Grid container columns={12} justifyContent="space-between" pl={2}>
          <Grid item xs={11} sm={5} md={3} lg={3}>
            <TextField
              //sx={{ width: 100, height: 45, border: 1, borderRadius: 1 }}\
              value={modificationPercentage}
              type={"number"}
              onChange={(e) => setModificationPercentage(e.target.value)}
              disableUnderline={true}
              autoFocus={false}
              variant="outlined"
              label={"% Modification"}
              size="small"
              fullWidth
            ></TextField>
          </Grid>

          <Grid item xs={1} sm={1} md={1} lg={1}>
            <Button
              //startIcon={<CheckRoundedIcon />}
              variant="outlined"
              style={{
                width: "90px",
                height: "45px",
                background: "#007DC3",
                color: "white",
                borderRadius: "4px",
                textTransform: "none",
                marginTop: 1,
              }}
              // onClick={() => modPercFunc.current()}
              onClick={handleOverallModification}
            >
              Apply
            </Button>
          </Grid>

          <Grid item xs={11} sm={5} md={3} lg={3}>
            <TextField
              //sx={{ width: 100, height: 45, border: 1, borderRadius: 1 }}
              value={rounder}
              type={"number"}
              disableUnderline={true}
              autoFocus={false}
              label={"Rounder"}
              variant="outlined"
              onChange={(e) => setRounder(e.target.value)}
              size="small"
              fullWidth
            ></TextField>
          </Grid>

          <Grid item xs={1} sm={1} md={1} lg={1}>
            <Button
              //startIcon={<CheckRoundedIcon />}
              variant="outlined"
              style={{
                width: "90px",
                height: "45px",
                background: "#007DC3",
                color: "white",
                borderRadius: "4px",
                textTransform: "none",
                marginTop: 3,
              }}
              //onClick={() => rounderFunc.current()}
              onClick={handleRounder}
            >
              Apply
            </Button>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <Button
              //startIcon={<ArrowDownwardRoundedIcon/>}
              disabled={ModifiedList?.depletionModel?.toLowerCase() === "none"}
              variant="outlined"
              style={{
                width: "200px",
                height: "45px",
                background: "rgba(245, 246, 250)",
                color: "steelblue",
                borderRadius: "4px",
                textTransform: "none",
                marginTop: 3,
              }}
              onClick={pullForwardQuota}
            >
              <strong>Pull forward Quota</strong>
            </Button>
          </Grid>
        </Grid>
        <Box mt={-1}>
          <Grid container columns={12} justifyContent="space-between" pl={2}>
            <FormControlLabel
              label="Only Selected Customers"
              control={
                <Checkbox
                  checked={isOnlySelectedCustomers}
                  onChange={handleIsOnlySelected}
                />
              }
            />
          </Grid>
        </Box>
      </Box>
      <Box m={2} mt={4}>
        <FormControl>
          <InputLabel sx={{ backgroundColor: "#fff", px: 1 }} id="select-label">
            Select Values
          </InputLabel>
          <Select
            labelId="select-label"
            id="select"
            multiple
            fullWidth
            value={selectedValues}
            onChange={handleSelectChange}
            renderValue={(selected) => (
              <div>
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    onDelete={() => {}}
                    deleteIcon={
                      <ClearIcon onMouseDown={handleSelectDelete(value)} />
                    }
                  />
                ))}
              </div>
            )}
          >
            {selectInitialValues?.map((value) => (
              <MenuItem key={value} value={value}>
                <Checkbox checked={selectedValues.includes(value)} />
                {value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {displayModification && (

          <DataGrid
            sx={{
              fontFamily: "Montserrat, Sans-serif",
              "& .MuiDataGrid-columnHeaderTitleContainer": {
                fontWeight: "bold !important",
                fontSize: "14px",
                fontFamily: "Montserrat, Sans-serif",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
                fontWeight: "bold",
                fontSize: "14px",
                fontFamily: "Montserrat, Sans-serif",
              },
              "& .MuiDataGrid-columnHeader": {
                // Forced to use !important since overriding inline styles
                height: "unset !important",
                backgroundColor: "rgba(245, 246, 250)",
              },
              "& .MuiDataGrid-columnHeaders": {
                // Forced to use !important since overriding inline styles
                maxHeight: "168px !important",
              },
              "& .MuiDataGrid-row": {
                backgroundColor: "none !important",
              },
              "& .Mui-selected": {
                backgroundColor: "none !important",
              },
            }}
            //style={{ maxHeight: "70vh" }}
            apiRef={apiRef}
            rows={rows || []}
            columns={visibleColumns}
            getRowId={(row) => row?.customerQuotaID}
            rowKey={(row) => row?.customerQuotaID}
            //sx={{ width: '98%' }}
            rowHeight={200}
           // autoHeight = {true}
            pageSizeOptions={[20, 50, 100]}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            checkboxSelection={true}
            disableRowSelectionOnClick
            disableColumnMenu
            onRowSelectionModelChange={(newRowSelectionModel) => {
              //console.log(newRowSelectionModel);
              // let updatedRow = [
              //   ...new Set([...rowSelectionModel, ...newRowSelectionModel]),
              // ];
              setRowSelectionModel(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            getRowClassName={getRowClassName}
            headerHeight={40}
            disableVirtualization = {true}
            
            //rowBuffer = {8}
            //rowBufferPx = {100}
            //rowSelectionModel={rowSelectionModel.length > 0 ? rowSelectionModel : checkedCustomersList}
          />
      )}
      <Box mt={3}>
        <Grid container columns={12} justifyContent="flex-end" spacing={3}>
          <Grid item xs={6} sm={6} md={1.5} lg={1.5}>
            <Button
              //startIcon={<LabelImportantRoundedIcon />}
              sx={{ height: 45 }}
              variant="outlined"
              id="SearchButton"
              disabled={!isRestrictedAccess}
              style={{
                background: "rgba(245, 246, 250)",
                color: "steelblue",
                borderRadius: "4px",
                textTransform: "none",
              }}
              fullWidth
              onClick={handleChooseFile}
            >
              Choose File
            </Button>
          </Grid>
          <Grid item xs={6} sm={6} md={2} lg={2}>
            <Button
              //startIcon={<LabelImportantRoundedIcon />}
              sx={{ height: 45, mb: 3 }}
              variant="contained"
              id="SearchButton"
              disabled={!isRestrictedAccess}
              style={{
                // background: "#286aa6",
                color: "white",
                borderRadius: "4px",
                textTransform: "none",
                boxShadow: "none",
              }}
              fullWidth
              onClick={handleSubmit}
            >
              Submit Modification
            </Button>
          </Grid>
        </Grid>

        {displayFileButtons && (
          <Grid>
            <Typography
              className="compHeading"
              sx={{ color: "#007DC3", fontWeight: "bold" }}
            >
              Choose File
            </Typography>
            <Grid
              container
              columns={12}
              justifyContent="flex-end"
              spacing={2}
              mt={2}
            >
              <Grid item xs={6} sm={1.5} md={1.5} lg={1.4}>
                <Button
                  //startIcon={<LabelImportantRoundedIcon />}
                  sx={{ width: "100%", height: 45, mb: 3 }}
                  variant="outlined"
                  id="SearchButton"
                  style={{
                    background: "#007DC3",
                    color: "white",
                    borderRadius: "4px",
                    textTransform: "none",
                  }}
                  fullWidth
                  onClick={() => hiddenFileInput.current.click()}
                >
                  <input
                    type="file"
                    accept=".xlsx"
                    ref={hiddenFileInput}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      handleSelectFile(file);
                    }}
                    style={{ display: "none", marginLeft: "100%" }}
                    id="fileInput"
                    onclick="fileInput.value = null"
                    value=""
                  />
                  Select File
                </Button>
              </Grid>
              {uploadedFile && (
                <Grid item xs={6} sm={1.5} md={1.5} lg={1.4}>
                  <Button
                    //startIcon={<LabelImportantRoundedIcon />}
                    sx={{ width: "100%", height: 45 }}
                    variant="outlined"
                    id="SearchButton"
                    style={{
                      background: "#007DC3",
                      color: "white",
                      borderRadius: "4px",
                      textTransform: "none",
                    }}
                    fullWidth
                    onClick={handleImportFile}
                  >
                    Import
                  </Button>
                </Grid>
              )}

              <Grid item xs={6} sm={1.5} md={1.5} lg={1.4}>
                <Button
                  //startIcon={<LabelImportantRoundedIcon />}
                  sx={{ width: "100%", height: 45 }}
                  variant="outlined"
                  id="SearchButton"
                  style={{
                    background: "#007DC3",
                    color: "white",
                    borderRadius: "4px",
                    textTransform: "none",
                  }}
                  fullWidth
                  onClick={handleExportFile}
                >
                  Export File
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Box sx={{ mt: -5 }}>
          {uploadedFile && (
            <div className="file-display">
              <span>{uploadedFile.name}</span>
              <Button
                sx={{ ml: 3 }}
                variant="outlined"
                color="secondary"
                onClick={handleDelete}
              >
                <DeleteIcon />
              </Button>
            </div>
          )}
        </Box>
      </Box>
      <Box>
        {ModifiedList?.quotaModificationFiles?.length > 0 && (
          <Stack direction="row" alignItems="center" gap={2}>
            {/* <SpeakerNotesOutlined color="info" /> */}
            <Typography sx={{ color: "#007DC3", fontWeight: "bold", mb: 4 }}>
              {/* Attachments */}
            </Typography>
          </Stack>
        )}
        <Table>
          <TableBody>
            {ModifiedList?.quotaModificationFiles?.map((row) => {
              return (
                <TableRow className="tableRow" key={row?._id}>
                  <TableCell className="tableCell" sx={{ flexGrow: 1 }}>
                    {row.filePath}
                  </TableCell>
                  <TableCell className="tableCell">
                    <Button
                      variant="outlined"
                      startIcon={<DownloadOutlined />}
                      size="small"
                      onClick={() => handleDownloadFile(row.filePath)}
                    >
                      Download
                    </Button>{" "}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {/* <FileAttach />
               <Attachments /> */}
      </Box>
      <Box sx={{ mt: 6 }}>
        <Typography
          className="compHeading"
          sx={{ color: "#007DC3", fontWeight: "bold" }}
        >
          Attach File
        </Typography>{" "}
        <Box>
          <input hidden type="file" ref={inputRef} onChange={uploadFile} />
          <Typography sx={{ fontWeight: "bold", mt: 4, ml: 1 }}>
            File Attachment
          </Typography>
          <Button
            sx={{
              bgcolor: "blue.main",
              color: "white.main",
              fontWeight: "700",
              mt: -5,
              ml: "calc(100% - 140px);",
              "&:hover": {
                bgcolor: "skyBlue.main",
                color: "black.main",
              },
            }}
            startIcon={<AttachmentIcon />}
            disabled={!isRestrictedAccess}
            onClick={handleInputClick}
          >
            Attach File
          </Button>
        </Box>
        <Box
          sx={{
            height: "auto",
            pt: 1.4,
            pl: 1,
            borderRadius: 2,
            mt: -2,
          }}
        >
          {/* <Typography sx={{ fontWeight: "bold" }}>Attachments</Typography>{" "} */}
          <List dense={false}>
            {files.map((file, index) => {
              return (
                <ListItem
                  sx={{ bgcolor: "blue.light" }}
                  key={index}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => handleDeleteFile(file)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: "blue.main" }}>
                      <InsertDriveFileIcon sx={{ color: "blue.light" }} />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={file.name}
                    secondary={false ? "Secondary text" : null}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
          sx={{ mt: 2, mb: 1 }}
        >
          <Typography
            sx={{ color: "#007DC3", fontWeight: "bold", width: "100%" }}
            className="compHeading"
          >
            <SpeakerNotesOutlined
              color="info"
              sx={{ width: 20, transform: " translate(0px, 6px)", mr: 1 }}
            />
            Comments
          </Typography>
        </Stack>
        <TextField
          className={"fullWidth"}
          size="large"
          multiline
          rows={6}
          onChange={(event) => setMainComments(event.target.value)}
          aria-label="minimum height"
          //placeholder="Comments"
          style={{ width: "100%", overflowY: "auto" }}
          defaultValue={ModifiedList?.comments}
        />
      </Box>

      {/* <Dialog
                disableEnforceFocus
                //fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <TextareaAutosize
                            onChange={handleComments}
                            aria-label="minimum height"
                            minRows={5}
                            //readOnly
                            placeholder="Comments"
                            style={{ width: 500, fontSize: 18 }}
                            value={userComments[selectedRowId]}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={() => handleClose()}
                        size="small"
                        style={{
                            background: "#286aa6",
                            color: "white",
                            borderRadius: "4px",
                        }}
                    >
                        Save
                    </Button>
                    {/* <Button
                            autoFocus
                            variant="contained"
                            onClick={() => handleConfirm()}
                            size="small"
                            style={{
                                background: "#286aa6",
                                color: "white",
                                borderRadius: "4px",
                            }}
                        >
                            Save Changes
                        </Button> */}
      {/* </DialogActions>
            </Dialog> */}
    </div>
  );
};

export default Modification;
